import axios from 'axios';
import {clarify} from "@/utils/clear";

class PresentApi {
    constructor() {
        this.endpoint = process.env.VUE_APP_BASE_API;
    }


    list(body) {
        const params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/present/list`, {params}).then(response=>response.data);
    }

    get(presentId) {
        return axios.get(`${this.endpoint}/present/get/${presentId}`, {}).then(response=>response.data);
    }

    save(present) {
        return axios.post(`${this.endpoint}/present/save`, present).then(response=>response.data);
    }

    delete(presentId) {
        return axios.delete(`${this.endpoint}/present/delete/${presentId}`, {}).then(response=>response.data);
    }

    uploadImage(f) {
        const formData = new FormData();
        formData.append('file', f);
        return axios.post(`${this.endpoint}/present/upload/image`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => response.data);
    }

    productList(presentId) {
        return axios.get(`${this.endpoint}/present/${presentId}/products`, {}).then(response=>response.data);
    }

    getProduct(presentId, presentProductId) {
        return axios.get(`${this.endpoint}/present/${presentId}/products/${presentProductId}`, {}).then(response=>response.data);
    }

    saveProducts(presentId, presentProducts) {
        // const formData = new FormData();
        // formData.append("presentProducts", presentProducts)
        return axios.post(`${this.endpoint}/present/${presentId}/products/save`, presentProducts).then(response=>response.data);
    }

}


export default new PresentApi();
